module.exports = __webpack_public_path__ + "static/media/case_02.e403f022.jpg";